import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as templateApi from '../../api/templateApi';

// Async Thunks
export const fetchTemplates = createAsyncThunk(
  'templates/fetchTemplates',
  async (workspaceId, { rejectWithValue }) => {
    try {
      const response = await templateApi.fetchTemplates(workspaceId);
      return response.templates || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createTemplate = createAsyncThunk(
  'templates/createTemplate',
  async (templateData, { rejectWithValue }) => {
    try {
      const response = await templateApi.createTemplate(templateData);
      return response.template;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  'templates/deleteTemplate',
  async (templateId, { rejectWithValue }) => {
    try {
      await templateApi.deleteTemplate(templateId);
      return templateId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createPageFromTemplate = createAsyncThunk(
  'templates/createPageFromTemplate',
  async ({ templateId, workspaceId, parentId }, { rejectWithValue }) => {
    try {
      const response = await templateApi.createPageFromTemplate(templateId, { workspaceId, parentId });
      return response.page;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const savePageAsTemplate = createAsyncThunk(
  'templates/savePageAsTemplate',
  async ({ pageId, name, description, category }, { rejectWithValue }) => {
    try {
      const response = await templateApi.savePageAsTemplate({ pageId, name, description, category });
      return response.template;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const templateSlice = createSlice({
  name: 'templates',
  initialState: {
    templates: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTemplateError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchTemplates
      .addCase(fetchTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload;
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // createTemplate
      .addCase(createTemplate.fulfilled, (state, action) => {
        state.templates.push(action.payload);
      })
      // deleteTemplate
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.templates = state.templates.filter((t) => t._id !== action.payload);
      })
      // savePageAsTemplate
      .addCase(savePageAsTemplate.fulfilled, (state, action) => {
        state.templates.push(action.payload);
      });
  },
});

export const { clearTemplateError } = templateSlice.actions;
export default templateSlice.reducer;
